import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/icon-gear.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-6",
  src: _imports_0
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }

import { defineModel, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
  icon: {
    type: String,
    required: false,
  },
  text: {
    required: false,
  },
},
  setup(__props) {

const props = __props;



const visibility = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visibility.value = !visibility.value)),
      class: "flex flex-row items-center gap-2 p-4 hover:scale-110 transition-all"
    }, [
      (__props.icon == 'icon-gear')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_mdicon, { name: __props.icon }, null, 8, ["name"])
          ])),
      _createElementVNode("p", null, _toDisplayString(__props.text), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (visibility.value = !visibility.value)),
      class: _normalizeClass([
        visibility.value ? '' : 'hidden',
        'absolute top-10 right-0 z-50 flex flex-col w-max gap-2 p-4 rounded-md ease-out shadow-md bg-white transition-all',
      ])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ])), [
    [_directive_click_outside, () => (visibility.value = false)]
  ])
}
}

})